module.exports = __webpack_public_path__ + "static/media/fabio-mangioneOld2.2f83071f.jpg";